import { useState, useEffect } from 'react';
import { fetchModerationBlocks, getModerationImageSignedUrl } from '../lib/api.js';
import { Back } from '../components/Basic.jsx';
import { t as tr } from '../lib/i18n.js';
function timeAgo(iso){
  const diff=(Date.now()-new Date(iso).getTime())/1000;
  if(diff<3600) return tr("notif_time_min",{n:Math.floor(diff/60)});
  if(diff<86400) return tr("notif_time_hour",{n:Math.floor(diff/3600)});
  return tr("notif_time_day",{n:Math.floor(diff/86400)});
}
export function ModerationView({t,st,go}){
  const isAdmin=!!(st.profile&&st.profile.isAdmin);
  const [items,setItems]=useState([]);
  const [loading,setLoading]=useState(true);
  const [imageUrls,setImageUrls]=useState({});
  useEffect(()=>{
    if(!isAdmin) return;
    let mounted=true;
    (async()=>{
      const blocks=await fetchModerationBlocks(50);
      if(!mounted) return;
      setItems(blocks);
      setLoading(false);
      // Genera i link per vedere le foto bloccate, una alla volta, senza bloccare la lista
      blocks.filter(b=>b.type==="photo"&&b.contentUrl).forEach(async b=>{
        const url=await getModerationImageSignedUrl(b.contentUrl);
        if(mounted&&url) setImageUrls(prev=>({...prev,[b.id]:url}));
      });
    })();
    return ()=>{ mounted=false; };
  },[isAdmin]);
  if(!isAdmin) return(
    <div className="screen fade" style={{background:t.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:30,textAlign:"center"}}>
      <div style={{fontSize:40,marginBottom:14}}>🔒</div>
      <div style={{fontSize:14,color:t.soft,fontFamily:"Inter,sans-serif"}}>{tr("mod_locked_message")}</div>
    </div>
  );
  return(
    <div className="screen fade" style={{background:t.bg,display:"flex",flexDirection:"column"}}>
      <div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${t.ac}18`,flexShrink:0}}>
        <Back fn={()=>go("settings")} t={t}/>
        <span style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("mod_header_title")}</span>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"12px 16px 26px"}}>
        {loading?(
          <div style={{textAlign:"center",padding:"40px 0",color:t.soft,fontFamily:"Inter,sans-serif",fontSize:12.5}}>{tr("set_avatar_uploading")}</div>
        ):items.length===0?(
          <div style={{textAlign:"center",padding:"50px 20px"}}>
            <div style={{fontSize:36,marginBottom:12}}>✅</div>
            <div style={{fontSize:13,color:t.soft,fontFamily:"Inter,sans-serif"}}>{tr("mod_empty")}</div>
          </div>
        ):items.map(b=>(
          <div key={b.id} style={{background:t.card,borderRadius:14,border:`1px solid ${t.bord}`,padding:13,marginBottom:10}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:9}}>
              <span style={{fontSize:12.5,fontWeight:700,color:t.tx,fontFamily:"Inter,sans-serif"}}>@{b.username}</span>
              <span style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif"}}>{timeAgo(b.createdAt)}</span>
            </div>
            {b.type==="photo"?(
              imageUrls[b.id]
                ? <img src={imageUrls[b.id]} style={{width:"100%",maxWidth:220,borderRadius:10,display:"block",marginBottom:9}}/>
                : <div style={{fontSize:11,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:9}}>{tr("mod_image_loading")}</div>
            ):(
              <div style={{fontSize:13,color:t.tx,fontFamily:"Inter,sans-serif",fontStyle:"italic",background:t.bg,borderRadius:9,padding:"9px 11px",marginBottom:9,lineHeight:1.4}}>"{b.contentText}"</div>
            )}
            <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
              {Object.entries(b.reason||{}).filter(([,v])=>v).map(([cat])=>(
                <span key={cat} style={{fontSize:9,padding:"3px 8px",borderRadius:20,background:"#D9302522",color:"#D93025",fontFamily:"Inter,sans-serif",fontWeight:700}}>{cat}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
